import { useEffect, useRef, useState } from 'react';
import { Button, type ButtonVariant } from './Button.tsx';

/**
 * 공통 복사 버튼 (CR-066). value 를 클립보드에 넣고 1.5초간 "복사됨" 으로 바뀐다(토스트 없음).
 * 표 행·인라인은 기본 ghost, 단독 배치는 variant="secondary". 복사 기능은 이 컴포넌트만 쓴다.
 */
export function CopyButton({ value, label = '복사', copiedLabel = '복사됨', variant = 'ghost', className = '', disabled }: {
  value: string | (() => string); label?: string; copiedLabel?: string; variant?: ButtonVariant; className?: string; disabled?: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
  async function copy() {
    const text = typeof value === 'function' ? value() : value;
    try { await navigator.clipboard.writeText(text); }
    catch { // 보안 컨텍스트가 아니면(http) clipboard API 가 없다 → 임시 textarea 로 복사
      const ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } finally { ta.remove(); }
    }
    setCopied(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1500);
  }
  return <Button variant={variant} className={className} disabled={disabled} onClick={copy} aria-live="polite" title={copied ? copiedLabel : '클립보드에 복사'}>{copied ? copiedLabel : label}</Button>;
}
